import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { retrievePageMenu } from "../../../../../redux/slice/page-menu.slice";
import { useAppDispatch, RootState } from "../../../../../redux/store";
import LoadingComp from "../../../../../components/re-usable/loading/loading";

const NominationProcessComponent = () => {
  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const path = "%2FWho-We-Are%2FGovernance%2FNomination-Process"; // %2FWho-We-Are%2FGovernance%2FNomination-Process page content

  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
    </>
  );
};

export default NominationProcessComponent;
